import { InsightsHubArticlesListResponse } from "@insightsHub/models";
import { AppThunkAPI } from "@shared/models/redux";
import { FEATURED_INSIGHTS_ENDPOINT } from "@home/constants";

type CallFeaturedInsightsAPI = () => AppThunkAPI<Promise<InsightsHubArticlesListResponse>>;

export const callFeaturedInsightsAPI: CallFeaturedInsightsAPI = () => async (_dispatch, _getState, extra) => {
  const response = await extra<InsightsHubArticlesListResponse>(FEATURED_INSIGHTS_ENDPOINT);

  return response.data;
};
